import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Button } from '@dasa-health/alma-react'
import { CheckRound, Close } from '@dasa-health/alma-icons'
import { Images } from '@nsw-paginas-deslogadas/assets'

import * as S from './styles'

type PromoBannerProps = {
    isAlta?: boolean
}

const PromoBanner = ({ isAlta = false }: PromoBannerProps) => {
    const [isOpen, setIsOpen] = useState(true)

    const { Coupon, CouponAlta, Copy } = Images

    const copyPromoCode = async (code: string) => {
        try {
            await navigator.clipboard.writeText(code)

            toast.success('Cupom copiado com sucesso.', {
                hideProgressBar: true,
                closeButton: false,
                autoClose: 3000,
                icon: <CheckRound color="#278142" height={24} width={24} />,
                style: {
                    padding: '8px 16px',
                },
                bodyStyle: {
                    marginLeft: '16px',
                    fontSize: '14px',
                    padding: '0',
                    whiteSpace: 'nowrap',
                },
            })
        } catch {
            toast.error('Não foi possível copiar o cupom.', {
                hideProgressBar: true,
                closeButton: false,
                autoClose: 3000,
                style: {
                    padding: '8px 16px',
                },
                bodyStyle: {
                    marginLeft: '16px',
                    fontSize: '14px',
                    padding: '0',
                    whiteSpace: 'nowrap',
                },
            })
        }
    }

    if (!isOpen) return null

    return (
        <S.Container data-testid="promo-banner">
            <S.Content>
                <S.Text1>Cupom de 15% de desconto em exames de detecção de câncer</S.Text1>

                {isAlta ? <S.Img alt={CouponAlta.alt} src={CouponAlta.src} /> : <S.Img alt={Coupon.alt} src={Coupon.src} />}

                <S.Text2>
                    <strong>Descontos exclusivos para exames</strong> de detecção do câncer de mama e de próstata.{' '}
                    <strong>Agende aqui e informe o cupom no momento do atendimento:</strong>
                </S.Text2>

                <S.Text2Mobile>
                    <strong>Agende aqui e informe o cupom no momento do atendimento:</strong>
                </S.Text2Mobile>

                <S.ButtonsContainer>
                    <Button
                        data-current-service="Página da Marca"
                        data-item-position="Header Banner"
                        data-item-text="OUTROSA15"
                        data-testid="promo-banner-copy-button1"
                        onClick={() => copyPromoCode('OUTROSA15')}
                        size="sm"
                        variant="secondary"
                    >
                        <S.Img alt={Copy.alt} src={Copy.src} />
                        <span>OUTROSA15</span>
                    </Button>

                    <Button
                        data-current-service="Página da Marca"
                        data-item-position="Header Banner"
                        data-item-text="NOVAZUL15"
                        data-testid="promo-banner-copy-button2"
                        onClick={() => copyPromoCode('NOVAZUL15')}
                        size="sm"
                        variant="secondary"
                    >
                        <S.Img alt={Copy.alt} src={Copy.src} />
                        <span>NOVAZUL15</span>
                    </Button>
                </S.ButtonsContainer>
            </S.Content>

            <S.CloseButton data-testid="promo-banner-close" onClick={() => setIsOpen(false)} title="Fechar" type="button">
                <Close color="#161616" height={24} width={24} />
            </S.CloseButton>
        </S.Container>
    )
}

export default PromoBanner
